import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	RequestViewerNewUserEmailVerification,
	type RequestViewerNewUserEmailVerificationMutation,
	type RequestViewerNewUserEmailVerificationMutationVariables,
} from './requestViewerNewUserEmailVerification.graphql';

export async function requestViewerNewUserEmailVerification(
	redirectUrl: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<boolean> {
	try {
		const { data } = await fetch<
			RequestViewerNewUserEmailVerificationMutation,
			RequestViewerNewUserEmailVerificationMutationVariables
		>({
			path: '/requestViewerNewUserEmailVerification',
			query: RequestViewerNewUserEmailVerification,
			variables: { input: { redirectUrl } },
			rejectOnError: true,
			batched: false, // to ensure this rate limited mutation is not batched
		});

		return data.requestViewerNewUserEmailVerification.__typename === 'RequestViewerNewUserEmailVerificationSuccess';
	} catch (e) {
		return false;
	}
}
